import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Storefront, SignOut } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function BusinessLayout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const onLogout = async () => { await logout(); nav("/login"); };
  return (
    <div className="min-h-screen bg-background pb-10">
      <header className="sticky top-0 z-30 bg-card border-b border-border">
        <div className="px-4 py-3 flex items-center justify-between max-w-2xl mx-auto">
          <div className="flex items-center gap-2">
            <Storefront size={22} weight="fill" className="text-violet-600" />
            <div>
              <div className="text-xs uppercase tracking-widest text-muted-foreground">İşletme Paneli</div>
              <div className="font-bold" data-testid="business-user-name">{user?.name}</div>
            </div>
          </div>
          <Button variant="ghost" size="icon" onClick={onLogout} data-testid="business-logout">
            <SignOut size={18} />
          </Button>
        </div>
      </header>
      <main className="max-w-2xl mx-auto px-4 py-6">{children}</main>
    </div>
  );
}
